import React from 'react';
import { format } from 'd3-format';
import { map, apply, prop } from 'ramda';

import { Scale, getTickFormat, Timeslice } from 'scenes/Report/Report.helper';

export const maxScale = (points: Scale[]): number =>
  apply(Math.max, map<Scale, number>(prop('y'), points));

const scalingCalc = (maxScale: number, value: number, multiplier = -1) =>
  value * Math.pow(parseFloat(format('.2r')(maxScale)), multiplier);

const tickScalingData = (
  data: Scale[],
  formatType = '$,.0f',
  fixedMaxScale?: number,
) => (tick: number): string =>
  format(formatType)(scalingCalc(fixedMaxScale || maxScale(data), tick, 1));

const scalingData = (data: Scale[], fixedMaxScale?: number): Scale[] =>
  map((scale: Scale) => ({
    x: scale.x,
    y: scalingCalc(fixedMaxScale || maxScale(data), scale.y),
  }))(data);

const tickTimesliceFormat = (timeslice: Timeslice) => (
  value: string,
): JSX.Element => {
  const { top, bottom } = getTickFormat(timeslice, value);

  return (
    <tspan>
      <tspan x="0" dy="1em">
        {top}
      </tspan>

      <br />

      <tspan x="0" dy="1em">
        {bottom}
      </tspan>
    </tspan>
  );
};

export { tickScalingData, scalingData, tickTimesliceFormat, scalingCalc };
